<style scoped>
    .contract-expand{
        position: relative;
    }
    .expense-group-header, .expense-group-footer{
        text-align: center;
        font-weight: bold;
        padding: 6px;
    }
</style>
<template>
  <div class="contract-expand">
    <div v-if="!loading">
      <div class="line">
        <span>对方名称: {{ contract.payee_company }}</span>
        <span v-if="contract.payee_company_type === 0">证件号: {{ contract.payee_id_number }}</span>
      </div>
      <!--<div class="line" v-if="contract.parent.id">
                <span class="text-bold">主合同:</span>
                <ViewerItem :model_id="contract.parent.id" type="Contract">
                    <span class="link">{{contract.parent.uid}}-{{contract.parent.name}}</span>
                </ViewerItem>
            </div>
            <div class="line" v-if="contract.contracts && contract.contracts.length">
                <span class="text-bold">子合同:</span>
                <ViewerItem :model_id="sub_contract.id" type="Contract" v-for="sub_contract in contract.contracts" :key="sub_contract.id">
                    <span class="link">{{sub_contract.uid}}-{{sub_contract.name}}</span>
                </ViewerItem>
            </div>-->
      <div
        v-if="contract.link_contracts.length"
        class="value"
      >
        <span class="text-bold">关联合同:</span>
        <div
          v-for="link_contract in contract.link_contracts"
          :key="link_contract.id"
        >
          <ViewerItem
            :model_id="link_contract.id"
            type="Contract"
          >
            <span class="link">{{ link_contract.uid }}</span>
          </ViewerItem>
          <span> - {{ link_contract.name }}</span>
        </div>
      </div>
      <div
        v-if="contract.contract_stocks.length"
        class="line"
      >
        <Table
          :columns="columns"
          :data="contract.contract_stocks"
          size="small"
        >
          <div
            slot="header"
            style="padding: 6px; text-align: center; font-weight: bold;"
          >
            订单详情
          </div>
        </Table>
        <div class="line">
          <StockArrived
            :contract_id="contract.id"
            size="small"
          />
        </div>
        <div v-if="contract.contract_stock_parts&&contract.contract_stock_parts.length">
          <StockParts :list="contract.contract_stock_parts" />
        </div>
      </div>
      <div class="line">
        <ExpenseGroupHistory
          relate="contract_id"
          :relate_id="contract.id"
        />
      </div>
      <div class="hr" />
      <div
        v-if="contract.bfiles.length"
        class="line"
      >
        <span class="text-bold">附件:</span>
        <Attachments :files="contract.bfiles" />
      </div>
      <div
        v-else
        class="line"
      >
        没有添加附件
      </div>
      <div class="hr" />
      <div
        v-if="contract.files.length"
        class="line"
      >
        <span class="text-bold">电子归档文件:</span>
        <Attachments :files="contract.files" />
      </div>
      <div
        v-else
        class="line"
      >
        暂未上传电子归档文件
      </div>
      <div
        v-if="contract.desc"
        class="line text-bold"
      >
        备注:
      </div>
      <div
        v-if="contract.desc"
        v-html="contract.desc"
      />
      <div class="hr" />
      <div
        v-if="contract.user_flow"
        class="line"
      >
        <UserFlow :user_flow="contract.user_flow" />
      </div>
    </div>
    <Spin
      v-else
      fix
    />
  </div>
</template>
<script>
  import Attachments from '../../components/file/attachments';
  import ViewerItem from '../../components/viewer/item';
  import ExpenseGroupHistory from '../../expense_group/components/history';
  import StockArrived from '../../stock/components/stock_arrived';
  import StockParts from './stock_parts.vue'
  import ContractUtil from '../../contract/libs/util';
  import {mapGetters} from "vuex";
  export default {
    components: { Attachments, ViewerItem, StockArrived, ExpenseGroupHistory, StockParts },
    props: {
      id: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        loading: false,
        contract: {},
        columns_bak:[
          {
            title: '存货编码',
            align: 'center',
            key: 'uid',
            render: (h, params) => {
              const stock = params.row.stock;
              return h(ViewerItem, {
                props: {
                  model_id: stock.id,
                  type: 'Stock'
                },
                'class': {
                  'link': true
                }
              }, stock.uid)
            }
          },
          {
            title: '存货名称',
            align: 'center',
            key: 'name',
            render: (h, params) => {
              const stock = params.row.stock;
              return h('div', stock.name)
            }
          },
          {
            title: '条码/ISBN',
            align: 'center',
            key: 'name',
            render: (h, params) => {
              const stock = params.row.stock;
              return h('div', stock.barcode || '-')
            }
          },
          {
            title: '采购数量',
            align: 'right',
            key: 'qty',
            render: (h, params) => {
              return h('div', Util.formatNumber(params.row.qty));
            }
          },
          {
            title: '采购单价',
            align: 'right',
            key: 'unit_price',
            render: (h, params) => {
              return h('div', Util.formatPrice(params.row.unit_price));
            }
          },
          {
            title: '总价',
            align: 'right',
            key: 'total_price',
            render: (h, params) => {
              return h('div', Util.formatPrice(params.row.total_price));
            }
          },
          {
            title: '预计到货时间',
            align: 'center',
            key: 'estimate_arrival_time',
            render: (h, params) => {
              const row = params.row;
              return h('span', row.estimate_arrival_time || '-');
            }
          }
        ]
      }
    },
    computed: {
      ...mapGetters({
        warehouses_hash: 'async/warehouses_hash',
      }),
      columns() {
        const columns = [
          {
            title: '存货',
            align: 'center',
            width: 100,
            render: (h, params) => {
              const row = params.row;
              const ret = [
                h(ViewerItem, {
                  props: {
                    model_id: row.stock.id,
                    type: 'Stock'
                  },
                  'class': {
                    'link': true
                  }
                }, row.stock.uid),
                h('div', row.stock.name)
              ];
              return h('div', ret)
            }
          },
          {
            title: '条码/ISBN',
            align: 'center',
            width: 100,
            render: (h, params) => {
              const stock = params.row.stock;
              return h('div', stock.barcode || '-')
            }
          },

        ];
        if (this.contract.bill_type === 'OutSourcing') {
          columns.push({
            title: '入库类型',
            align: 'center',
            width: 60,
            render: (h, params) => {
              const row = params.row;
              if (row.stock_in_type === 'need') {
                return h('div', {
                  'class':{
                    'color-success': true
                  }
                }, '需要入库');
              } else if (row.stock_in_type === 'none') {
                return h('div', {
                  'class':{
                    'color-grey': true
                  }
                }, '无需入库');
              }
              return h('div', '-');
            }
          },)
        }
        return columns.concat([
          {
            title: '采购数量',
            align: 'right',
            width: 60,
            render: (h, params) => {
              const row = params.row;
              return h('span', Util.formatNumber(row.qty));
            }
          },
          {
            title: '到货数量',
            align: 'right',
            width: 60,
            render: (h, params) => {
              const row = params.row;
              return h('span', Util.formatNumber(row.arrived_qty));
            }
          },
          {
            title: '剩余数量',
            align: 'right',
            width: 60,
            render: (h, params) => {
              const row = params.row;
              return h('span', Util.formatNumber(math.eval(`${row.qty} - ${row.arrived_qty}`).toFixed(2)));
            }
          },
          {
            title: '采购单价',
            align: 'right',
            width: 60,
            render: (h, params) => {
              return h('div', Util.formatPrice(params.row.unit_price));
            }
          },
          {
            title: '仓库分配',
            align: 'right',
            width: 150,
            render: (h, params) => {
              const row = params.row;
              const csws = row.contract_stock_warehouses;
              if (csws && csws.length) {
                const ret = [];
                csws.forEach((csw) => {
                  ret.push(h('div', `${this.getWarehouseName(csw.warehouse_id)}: ${csw.qty}`))
                });
                return h('div', ret);
              } else {
                return h('div', '-');
              }
            }
          },
          {
            title: `总价 ${this.$util.formatPrice(this.contract.stock_total_price)}`,
            align: 'right',
            key: 'total_price',
            width: 100,
            render: (h, params) => {
              return h('div', Util.formatPrice(params.row.total_price));
            }
          },
          {
            title: '预计到货时间',
            align: 'center',
            key: 'estimate_arrival_time',
            width: 100,
            render: (h, params) => {
              const row = params.row;
              return h('span', row.estimate_arrival_time || '-');
            }
          },
          {
            title: '备注',
            align: 'center',
            key: 'remarks',
            minWidth: 200,
          }
                
        ])
      }
    },
    created() {
      this.getContract();
    },
    mounted() {
      //
    },
    methods: {
      getContract() {
        this.loading = true;
        ContractUtil.getDetail(this.id).then((data) => {
          this.contract = data.contract;
        }).catch((e) => {
          let err_msg = '<p>获取数据失败, 请重试!</p>';
          err_msg += e.message;
          this.$Modal.error({title: '提示', content: err_msg});
          this.config.modal = false;
        }).finally(() => {
          this.loading = false;
        });
      },
      downloadAttachment(bfile) {
        return Util.downloadToBlank({
          id: bfile.id
        })
       
      },
      getWarehouseName(id) {
        const wh = this.warehouses_hash[id];
        return wh ? wh.name : '未定义仓库';
      }
    }
  }
</script>
